import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useLanguage } from "./LanguageProvider";
import LanguageSelector from "./LanguageSelector";

export default function Navigation() {
  const { t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { label: "The Specimen", href: "#specimen" },
    { label: "Gallery", href: "#gallery" },
    { label: "Certification", href: "#certification" },
    { label: "Significance", href: "#valuation" },
    { label: "Documents", href: "#documents" },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav data-testid="main-nav" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${scrolled ? "bg-[#0A0A09]/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 flex items-center justify-between h-14 sm:h-16 lg:h-20">
        <a href="#top" className="font-serif text-lg sm:text-xl lg:text-2xl tracking-tight text-[#F4F0EA] hover:text-[#C5A059] transition-colors duration-500">
          THE BRIDGETTE
        </a>

        <div className="hidden lg:flex items-center gap-6 xl:gap-8">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} className="text-sm tracking-[0.1em] uppercase text-[#F4F0EA]/60 hover:text-[#C5A059] transition-colors duration-500 whitespace-nowrap">
              {link.label}
            </a>
          ))}
          <LanguageSelector />
        </div>

        <div className="flex items-center gap-3 lg:hidden">
          <LanguageSelector variant="minimal" />
          <button data-testid="mobile-menu-toggle" className="text-[#F4F0EA]/70 hover:text-[#C5A059] transition-colors p-1" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} className="lg:hidden bg-[#0A0A09]/90 backdrop-blur-2xl border-b border-white/10">
            <div className="px-6 py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <a key={link.href} href={link.href} onClick={() => setMobileOpen(false)} className="text-base tracking-[0.06em] uppercase text-[#F4F0EA]/70 hover:text-[#C5A059] transition-colors">
                  {link.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
